import axios from "axios";
import { baseUrl, portal } from "../App";
import { EVENT_ID } from "../assets/constant";

export const fetchLeaderboardForIndividual = async (leaderboardName,token,playerData) => {
  if(!leaderboardName || !token) return {};
  
  if(leaderboardName === 'leaderboard_daily' || leaderboardName === 'leaderboard_weekly' || leaderboardName === 'leaderboard_tournament' || leaderboardName === 'leaderboard_bcs'){
    let activeUserLeaderboard = leaderboardName === 'leaderboard_daily' ? EVENT_ID.DAILY_EVENT : leaderboardName === 'leaderboard_weekly' ? EVENT_ID.WEEKLY_EVENT : leaderboardName === 'leaderboard_tournament' ? EVENT_ID.TOURNAMENT_EVENT : leaderboardName === 'leaderboard_bcs' ? EVENT_ID.BCS_EVENT : '';
    
    
    const res = await axios.get(`${baseUrl}/api/participantProfile/user_leaderboard/?portal=${portal}`, {
      headers: { Authorization: `Token ${token}` }
    });
    let userLeaderboard = res?.data?.leaderboard ?? [];
    const serverData = userLeaderboard?.find(item => item.event_id === activeUserLeaderboard) || {};
    
    if (serverData?.time_taken === 0 && serverData?.score === 0) {
      return {};
    }
    
    return serverData;
  }
  else if(leaderboardName === 'winner_weekly'){
    const res = await axios.get(`${baseUrl}/money/tWinnerUserDefinedApiFrontend/?quizid=${EVENT_ID.WEEKLY_EVENT}&msisdn=${playerData?.msisdn}`);
    return {};
    return res.data;
  }
  else{
    return {};
  }
}